<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <search-bar ref="search-bar" />
    <vc-pager :show-prev-next="false" :show-first-last="false" size="small" v-if="showPager" :pages="computedPages" v-model="page" :class="['my-16']" />
    <ul :class="['search-results']" v-if="results.length">
      <li v-for="(result, index) in pagedResults" :key="index">
        <h3 :class="titleCss">
          <router-link :to="result.slug" v-html="result.data.title" />
        </h3>
        <p :class="descriptionCss" v-html="result.data.longDescription" />
        <div :class="slugCss">{{ protocol }}{{ hostname }}{{ result.slug }}</div>
      </li>
    </ul>
    <vc-pager :show-prev-next="false" :show-first-last="false" size="small" v-if="showPager" :pages="computedPages" v-model="page" :class="['my-16']" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'SearchPage',
  mixins: [
    methods
  ],
  computed: {
    pagedResults () {
      return this.results.slice((this.page - 1) * this.resultsPerPage, this.resultsPerPage * this.page)
    },
    showPager () {
      return this.results.length > 0 && this.results.length > this.resultsPerPage
    },
    computedPages () {
      return Math.ceil(this.results.length / this.resultsPerPage)
    }
  },
  data () {
    return {
      page: 1,
      resultsPerPage: 10,
      title: null,
      description: null,
      results: [],
      titleCss: [
        'subheading',
        'font-grey',
        'font-l-600'
      ],
      descriptionCss: [
        'body-2',
        'font-grey',
        'font-l-600'
      ],
      slugCss: [
        'caption',
        'font-grey',
        'font-l-600'
      ],
      hostname: location.hostname,
      protocol: `${location.protocol}//`
    }
  },
  watch: {
    '$route.query.q' () {
      this.search()
    }
  },
  mounted () {
    this.getPage()
    this.search()
  },
  methods: {
    search () {
      const store = this.$store
      const events = this.$store.state.events
      const apiEndpoint = store.getters.apiEndpoint
      const root = this.$root
      const route = this.$route
      const path = route.path
      const ajaxEnd = events.ajaxEnd
      const q = route.query.q
      this.results = []
      if (!q) {
        return
      }
      this.sendGaEvent('Search', 'site search', q)
      this.$refs['search-bar'].q = q
      root.$emit(events.ajaxStart)
      this.$http(`${apiEndpoint}${path}?json&q=${q}`)
        .then(response => {
          response = response.data
          const results = []
          const query = response.query
          const length = response.results.length
          if (length) {
            this.title = `${length} results found for "${query}"`
          } else {
            this.title = `<span class="font-red">Bummer... Nothing found for "${query}"</span>`
          }
          response.results.forEach(item => {
            results.push({
              slug: Object.keys(item)[0],
              data: Object.values(item)[0]
            })
          })
          this.results = results
          root.$emit(ajaxEnd)
        })
        .catch((error) => {
          console.log('[api error]', error)
          this.$root.$emit(ajaxEnd)
        })
    }
  }
}
</script>
<style>
.search-results,
.search-results p,
.search-results h3,
.search-results li
{
  padding: 0;
  margin: 0;
  list-style: none;
}

.search-results h3 a
{
  color: inherit;
}

.search-results li:not(:last-child)
{
  padding-bottom: 16px;
}

.search-results p
{
  margin: 8px 0;
}

.search-results p a
{
  color: inherit;
  text-decoration: none;
  -webkit-pointer-events: none;
  -moz-pointer-events: none;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/search.vue